module.exports = __webpack_public_path__ + "img/second-icon.b13b17f0.png";